import { Checkbox } from '@mui/material'
import CheckBoxActive from 'assets/icons/checkBoxActive'
import { roundingNumber } from 'components/shared/processes'
import { TreatmentStatus } from 'models'
import { useEffect } from 'react'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { ReactComponent as CheckBox } from '../../../../../assets/icons/checkBox.svg'
import { treatmentsStatuses } from '../processes'
import RangeInputs from './RangeInputs'

const icon = <CheckBox />
const checkedIcon = <CheckBoxActive />

const TreatmentContentBlock = props => {
	const {
		toggleFilter,
		treatmentStatus,
		availableTreatmentValues,
		handleDayChange,
		setActiveFilters,
	} = props
	const isTreatmentDurationEnabled =
		treatmentStatus.statuses.length > 0 &&
		treatmentStatus.statuses.every(status => status === TreatmentStatus.Treated)
	const isDisabledTreatmentStatusDateInput = !isTreatmentDurationEnabled

	useEffect(() => {
		if (!isDisabledTreatmentStatusDateInput || !setActiveFilters) return

		setActiveFilters(prev => {
			if (
				prev.treatmentStatus.startOf === '' &&
				prev.treatmentStatus.endOf === ''
			) {
				return prev
			}

			return {
				...prev,
				treatmentStatus: {
					...prev.treatmentStatus,
					startOf: '',
					endOf: '',
				},
			}
		})
	}, [isDisabledTreatmentStatusDateInput, setActiveFilters])

	return (
		<>
			<ul>
				{treatmentsStatuses.map(status => (
					<li
						onClick={() => toggleFilter('treatmentStatus', status.key)}
						key={status.id}
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							padding: '6px 0px',
							cursor: 'pointer',
						}}
					>
						<Checkbox
							icon={icon}
							disableRipple
							checkedIcon={checkedIcon}
							style={{ padding: '0px 8px 0px 0px', margin: '0px' }}
							checked={treatmentStatus.statuses.includes(status.key)}
						/>
						<TypographyPrimary>{status.title}</TypographyPrimary>
					</li>
				))}
			</ul>
			<TypographyPrimary
				sx={{
					margin: '16px 0px',
					color: isDisabledTreatmentStatusDateInput
						? COLORS.secondaryFont
						: undefined,
				}}
			>
				Продолжительность, дни
			</TypographyPrimary>
			<RangeInputs
				disabled={isDisabledTreatmentStatusDateInput}
				startValue={treatmentStatus.startOf}
				endValue={treatmentStatus.endOf}
				availableStart={availableTreatmentValues?.startOf}
				availableEnd={availableTreatmentValues?.endOf}
				formatValue={value => roundingNumber(value, 0)}
				onStartChange={e => handleDayChange(e, 'treatmentStatus', 'startOf')}
				onEndChange={e => handleDayChange(e, 'treatmentStatus', 'endOf')}
			/>
		</>
	)
}

export default TreatmentContentBlock
